import service from '@/services/types/tarifa'

export const namespaced = true

export const state = () => ({
  list: []
})

export const mutations = {
  LIST: (state, objs) => {
    // no incluir tarifa 01 Tarifa 0% (Exento) porque la factura se rechaza.
    state.list = objs.filter(obj => obj.value !== '01')
  }
}

export const actions = {
  list: ({ commit, state }, value) => (state.list?.length ? state.list : service.list(value).then(result => commit('LIST', result) || result))
}

export const getters = {
  getTarifa: state => idTarifa => state.list.find(({ id }) => id === idTarifa)?.tarifa || 0
}
